export default __webpack_public_path__ + "static/media/ilo.c2fc7518.png";